export default { sha: '8b17de830c0be0f62af1c1b235c60cd05a41034c', buildNumber: 'undefined' }
